import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children"];
import React from 'react';
import { Grid } from 'semantic-ui-react';
import { TextAlignPropType, VerticalAlignPropType } from '../../services/proptypes';
import ContentImage from './ContentImage';
import ContentMarkup from './ContentMarkup';
export default function Content(_ref) {
  var children = _ref.children,
      gridProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  if (React.Children.count(children) === 0) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Grid, _extends({
    className: "content-section"
  }, gridProps), children);
}
Content.defaultProps = {
  children: null,
  columns: 'equal',
  textAlign: 'center',
  verticalAlign: 'middle'
};
Content.Markup = ContentMarkup;
Content.Image = ContentImage;